module.exports = {
  'en': {
    'STDEMP1': {
      '10': 'Employee"s Details',
      '20': 'Employee Code',
      '30': 'Status',
      '40': 'Level',
      '50': 'Hire Date',
      '60': 'Resigned Date',
      '70': 'Due. Date',
      '80': 'Service Year',
      '90': 'Yrs.',
      '100': 'Month',
      '110': 'Age',
      '120': 'Yrs.',
      '130': 'Month',
      '135': 'Date of Birth',
      '136': 'ID card',
      '140': 'Position',
      '150': 'Job Description',
      '160': 'Department',
      '170': 'Type of Employment',
      '180': 'Type of Employee',
      '190': 'Payroll Group',
      '200': 'Work Group',
      '210': 'Cause of dismissal',
      '220': 'Education',
      '230': 'สาขาวิชา',
      '240': 'Email Address',
      '250': 'Salary',
      '260': 'Birthday',
      '270': 'ID number',
      '280': 'Emp. History'
    },
    'STDEMPC1': {
      '1': 'Employee"s Details',
      '10': 'Employee Code',
      '15': 'Employment Data',
      '20': 'Department',
      '30': 'Position',
      '40': 'Level',
      '50': 'Job Description',
      '60': 'Type of Employment',
      '70': 'Type of Employee',
      '80': 'Payroll Group',
      '90': 'Salary',
      '100': 'Begin Date',
      '110': 'Service Year',
      '120': 'Year',
      '130': 'Month',
      '140': 'Age',
      '150': 'Year',
      '160': 'Month',
      '170': 'Yrs in Level',
      '180': 'Year',
      '190': 'Month',
      '200': 'Yrs in Position',
      '210': 'Year',
      '220': 'Month',
      '230': 'Education Level',
      '240': 'Institute',
      '250': 'Major',
      '260': 'Branch'
    },
    'STDEMPC2': {
      '10': 'Work Experience',
      '20': 'Seq',
      '30': 'Company Name',
      '40': 'Positon',
      '50': 'Begin Date',
      '60': 'End Date'
    },
    'STDEMPC3': {
      '10': 'History of Salary Increase',
      '20': 'History of Salary Increase',
      '30': 'Effective Date',
      '40': 'Old Salary',
      '50': 'New Salary',
      '60': 'History of performance appraisal',
      '70': 'Year',
      '80': 'Grade'
    },
    'STDEMPC4': {
      '10': 'History of Punishment',
      '20': 'Punishment',
      '30': 'Punishment Period',
      '40': 'Details Of Mistake'
    },
    'STDEMPC5': {
      '10': 'Others Data',
      '20': 'Personal Data',
      '30': 'History Data',
      '40': 'Work Data'
    },
    'STDEMPP1': {
      '10': 'Employee Name',
      '20': 'Employee Details',
      '30': 'Title',
      '40': 'First Name',
      '50': 'Last Name',
      '60': 'Contact Address',
      '70': 'Home Address',
      '80': 'Post/Zip',
      '90': 'Contact Address',
      '100': 'Post/Zip',
      '110': 'Tel. No.',
      '120': 'Place of Birth',
      '130': 'Ref. Application No.',
      '140': 'Other Detail',
      '150': 'Date of Birth',
      '160': 'Blood Group',
      '170': 'High',
      '180': 'Weight',
      '190': 'Military Service',
      '200': 'Mirital Status',
      '210': 'Gender',
      '220': 'Relegion',
      '230': 'Race',
      '240': 'Nationality',
      '250': 'ID. Card',
      '260': 'ID. Card No.',
      '270': 'Place of Issue',
      '280': 'Province',
      '290': 'Expire Date',
      '300': 'Driving License',
      '310': 'ID. License',
      '320': 'Expire Date',
      '330': 'Personal Data',
      '340': 'Male',
      '350': 'Female'
    },
    'STDEMPP10': {
      '10': 'Children Data',
      '20': 'Seq. No',
      '30': 'Children"s Name',
      '40': 'Brith Date',
      '50': 'Gender',
      '60': 'Last Update Date',
      '70': 'By'
    },
    'STDEMPP11': {
      '10': 'Skill Data',
      '20': 'Type of Skill',
      '30': 'Description',
      '40': 'Skill Level',
      '50': 'Years of Exp.',
      '60': 'Last Update Date',
      '70': 'By'
    },
    'STDEMPP12': {
      '10': 'Training Date',
      '20': 'Seq.',
      '30': 'Details of Training',
      '40': 'Train Date',
      '50': 'Place',
      '60': 'Last Update Date',
      '70': 'By'
    },
    'STDEMPP13': {
      '10': 'Employee "s  Award',
      '20': 'Received Date',
      '30': 'Type of Award',
      '40': 'Details',
      '50': 'Refer Doc. No.',
      '60': 'Last Update Date',
      '70': 'By'
    },
    'STDEMPP14': {
      '10': 'Change Name',
      '20': 'Date',
      '30': 'Pre. Name',
      '40': 'First Name',
      '50': 'Lastname',
      '60': 'Reason',
      '70': 'Last Update Date',
      '80': 'By'
    },
    'STDEMPP15': {
      '10': 'Other Data',
      '20': 'Seq.',
      '30': 'Description',
      '40': 'Value',
      '50': 'Last Update Date',
      '60': 'By'
    },
    'STDEMPP2': {
      '10': 'Date Start Job',
      '20': 'Start level Date',
      '30': 'Start Position Date',
      '40': 'Probation Period',
      '50': 'Employment Period',
      '60': 'Yrs.',
      '70': 'Mth.',
      '80': 'Comfirmation Date',
      '90': 'Inhouse Phone No.',
      '100': 'Email Address',
      '110': 'Refered Request No.',
      '120': 'Department',
      '130': 'Position',
      '140': 'Level',
      '150': 'Job Details',
      '160': 'Status',
      '170': 'Time Stamp',
      '180': 'Work Location',
      '190': 'Type of Employment',
      '200': 'Category',
      '210': 'Payroll Group',
      '220': 'Last Update Date',
      '230': 'By',
      '240': 'Group',
      '250': 'Employment Data',
      '260': 'Existing No. of Guarantor (Person)',
      '270': 'Existing Collateral Value (Baht)'
    },
    'STDEMPP3': {
      '10': 'No.',
      '20': 'Code Income',
      '30': 'Details',
      '40': 'Unit',
      '50': 'Currency',
      '60': 'Amount',
      '70': 'Total Earning Per Month',
      '80': 'Wage/Hour',
      '90': 'Last Date Update',
      '100': 'By',
      '110': 'Income Data'
    },
    'STDEMPP4': {
      '10': 'Tax Status',
      '20': 'Tax Detail',
      '30': 'Tax I.D No.',
      '40': 'Social(W/F) No.',
      '50': 'Tax Deduction',
      '60': 'Type Of Tax Payment',
      '70': 'Bank Detail',
      '80': 'Bank Code',
      '90': 'ID.Deposit Account',
      '100': 'Amount Money',
      '110': 'Bank Code',
      '120': 'ID.Deposit Account',
      '130': 'Details of Tax Deductible',
      '140': 'Seq.',
      '150': 'Description',
      '160': 'Curr.',
      '170': 'Amount',
      '180': 'YTD. Earning/Deduction',
      '190': 'Bal. Forward Date',
      '200': 'Total Income',
      '210': 'Tax Deduction',
      '220': 'P/F Contribution',
      '230': 'Social W/F',
      '240': 'Last Update Date',
      '250': 'By'
    },
    'STDEMPP5': {
      '10': 'Tax Status of Spouse',
      '20': 'Details of Tax Deduction',
      '30': 'Seq.',
      '40': 'Description',
      '50': 'Currency',
      '60': 'Amount',
      '70': 'YTD. Earning/Deduction',
      '80': 'Bal. Forward Date',
      '90': 'Total Income',
      '100': 'Tax Deduction',
      '110': 'P/F Contribution',
      '120': 'Social W/F',
      '130': 'Last Update Date',
      '140': 'By'
    },
    'STDEMPP6': {
      '10': 'Education Data',
      '20': 'No.',
      '30': 'Educ. Level',
      '40': 'Field',
      '50': 'Major',
      '60': 'Institute',
      '70': 'Country',
      '80': 'GPA.',
      '90': 'Year End',
      '100': 'Degree',
      '110': 'Last Date Update',
      '120': 'By'
    },
    'STDEMPP7': {
      '10': 'Work Experience',
      '20': 'No.',
      '30': 'Company Name',
      '40': 'Position',
      '50': 'Start Date',
      '60': 'End Date',
      '70': 'Last Date Update',
      '80': 'By',
      '90': 'Seq.',
      '100': 'Company "s Name',
      '110': 'Job Description',
      '120': 'Position',
      '130': 'Location',
      '140': 'Supervisor "s Name',
      '150': 'Reason of Resigned',
      '160': 'Last Salary',
      '170': 'Start Date',
      '180': 'Resigned Date',
      '190': 'Remark'
    },
    'STDEMPP8': {
      '10': 'Parent "s Information',
      '20': 'Parent "s Information',
      '30': 'Father "s Information',
      '40': 'Father "s Name',
      '50': 'Nationality',
      '60': 'Relegion',
      '70': 'Occupation',
      '80': 'Mother "s Information',
      '90': 'Mother "s Name',
      '100': 'Nationality',
      '110': 'Relegion',
      '120': 'Occupation',
      '130': 'Emergency Contact Person',
      '140': 'Name-Lastname',
      '150': 'Address',
      '160': 'Post/Zip',
      '170': 'Tel. No',
      '180': 'Fax.',
      '190': 'Email-Address',
      '200': 'Relationship',
      '210': 'Last Update Date',
      '220': 'By'
    },
    'STDEMPP9': {
      '10': 'Spouse Data',
      '20': 'Spouse Information',
      '30': 'Name -Lastname',
      '40': 'I.D. Card',
      '50': 'Occupatin',
      '60': 'Department',
      '70': 'Registration Information',
      '80': 'Registration date',
      '90': 'Place of Registration',
      '100': 'City',
      '110': 'Country',
      '120': 'Other',
      '130': 'Last Update Date',
      '140': 'By',
      '150': 'By'
    }
  },
  'th': {
    'STDEMP1': {
      '10': 'รายละเอียดพนักงาน',
      '20': 'รหัสพนักงาน',
      '30': 'สถานะ',
      '40': 'ระดับ',
      '50': 'วันที่เริ่มงาน',
      '60': 'วันที่ลาออก',
      '70': 'วันครบกำหนดทดลองงาน',
      '80': 'อายุงาน',
      '90': 'ปี',
      '100': 'เดือน',
      '110': 'อายุตัว',
      '120': 'ปี',
      '130': 'เดือน',
      '135': 'วันเกิด',
      '136': 'เลขที่บัตรประชาชน',
      '140': 'ตำแหน่ง',
      '150': 'ลักษณะงาน',
      '160': 'หน่วยงาน',
      '170': 'ประเภทการจ้างงาน',
      '180': 'ประเภทพนักงาน',
      '190': 'กลุ่มการจ่ายเงินเดือน',
      '200': 'กลุ่มพนักงาน',
      '210': 'สาเหตุการพ้นสภาพ',
      '220': 'การศึกษา',
      '230': 'สาขาวิชา',
      '240': 'อีเมล์',
      '250': 'เงินเดือน',
      '260': 'วันเกิด',
      '270': 'เลขที่บัตรประชาชน',
      '280': 'ประวัติพนักงาน'
    },
    'STDEMPC1': {
      '1': 'รายละเอียดพนักงาน',
      '10': 'รหัสพนักงาน',
      '15': 'ข้อมูลการจ้างงาน',
      '20': 'หน่วยงาน',
      '30': 'ตำแหน่ง',
      '40': 'ระดับ',
      '50': 'ลักษณะงาน',
      '60': 'ประเภทการจ้างงาน',
      '70': 'ประเภทพนักงาน',
      '80': 'กลุ่มการจ่ายเงินเดือน',
      '90': 'เงินเดือน',
      '100': 'วันที่เข้างาน',
      '110': 'อายุงาน',
      '120': 'ปี',
      '130': 'เดือน',
      '140': 'อายุ',
      '150': 'ปี',
      '160': 'เดือน',
      '170': 'อายุระดับ',
      '180': 'ปี',
      '190': 'เดือน',
      '200': 'อายุตำแหน่ง',
      '210': 'ปี',
      '220': 'เดือน',
      '230': 'ระดับการศึกษา',
      '240': 'สถาบัน',
      '250': 'สาขาการศึกษา',
      '260': 'สาขาวิชา'
    },
    'STDEMPC2': {
      '10': 'ประสบการณ์การทำงาน',
      '20': 'ลำดับที่',
      '30': 'ชื่อบริษัท',
      '40': 'ตำแหน่ง',
      '50': 'วันที่เข้างาน',
      '60': 'วันที่ออก'
    },
    'STDEMPC3': {
      '10': 'ประวัติการเพิ่มเงินเดือน',
      '20': 'ประวัติการเพิ่มเงินเดือน',
      '30': 'วันที่มีผลบังคับใช้',
      '40': 'เงินเดือนเดิม',
      '50': 'เงินเดือนที่ปรับ',
      '60': 'การประเมิน',
      '70': 'ปี',
      '80': 'เกรด'
    },
    'STDEMPC4': {
      '10': 'ประวัติการลงโทษ',
      '20': 'การลงโทษ',
      '30': 'ช่วงวันที่ลงโทษ',
      '40': 'รายละเอียดการกระทำผิด'
    },
    'STDEMPC5': {
      '10': 'รายละเอียดอื่น',
      '20': 'ข้อมูลส่วนตัว',
      '30': 'ประวัติส่วนตัว',
      '40': 'ข้อมูลการมาทำงาน'
    },
    'STDEMPP1': {
      '10': null,
      '20': null,
      '30': null,
      '40': null,
      '50': null,
      '60': null,
      '70': null,
      '80': null,
      '90': null,
      '100': null,
      '110': null,
      '120': null,
      '130': null,
      '140': null,
      '150': null,
      '160': null,
      '170': null,
      '180': null,
      '190': null,
      '200': null,
      '210': 'เพศ',
      '220': null,
      '230': null,
      '240': null,
      '250': null,
      '260': null,
      '270': null,
      '280': null,
      '290': null,
      '300': null,
      '310': null,
      '320': null,
      '330': null,
      '340': null,
      '350': null
    },
    'STDEMPP10': {
      '10': '*',
      '20': '*',
      '30': 'ชื่อบุตร',
      '40': 'วันเกิด',
      '50': 'เพศ',
      '60': '*',
      '70': 'โดย'
    },
    'STDEMPP11': {
      '10': '*',
      '20': 'ประเภทความสามารถ',
      '30': 'รายละเอียด',
      '40': '*',
      '50': '*',
      '60': '*',
      '70': 'โดย'
    },
    'STDEMPP12': {
      '10': 'ข้อมูล การฝึกอบรม',
      '20': 'ลำดับ',
      '30': 'รายละเอียดการฝึกอบรม',
      '40': 'วันที่ฝึกอบรม',
      '50': 'สถานที่ฝึกอบรม',
      '60': 'วันที่ ปรับข้อมูล',
      '70': 'โดย'
    },
    'STDEMPP13': {
      '10': 'ข้อมูลคุณความดี',
      '20': 'วันที่บันทึก',
      '30': 'ประเภทคุณความดี',
      '40': 'รายละเอียดคุณความดี',
      '50': 'เลขที่เอกสารอ้างอิง',
      '60': 'วันที่ป้อนข้อมูล',
      '70': 'โดย'
    },
    'STDEMPP14': {
      '10': null,
      '20': 'วันที่',
      '30': null,
      '40': null,
      '50': null,
      '60': null,
      '70': 'วันที่แก้ไขล่าสุด',
      '80': 'โดย'
    },
    'STDEMPP15': {
      '10': 'ข้อมูลอื่นๆ',
      '20': 'ลำดับ',
      '30': 'รายละเอียด',
      '40': 'ค่าต่างๆ',
      '50': 'วันที่ปรับปรุงข้อมูล',
      '60': 'โดย'
    },
    'STDEMPP2': {
      '10': null,
      '20': null,
      '30': null,
      '40': null,
      '50': null,
      '60': null,
      '70': null,
      '80': null,
      '90': null,
      '100': null,
      '110': null,
      '120': 'หน่วยงาน',
      '130': 'ตำแหน่ง',
      '140': 'ระดับ',
      '150': null,
      '160': 'สถานะ',
      '170': null,
      '180': null,
      '190': null,
      '200': null,
      '210': 'กลุ่มการจ่ายเงินเดือน',
      '220': 'วันที่แก้ไขล่าสุด',
      '230': 'โดย',
      '240': null,
      '250': null,
      '260': null,
      '270': null
    },
    'STDEMPP3': {
      '10': null,
      '20': null,
      '30': null,
      '40': null,
      '50': null,
      '60': null,
      '70': null,
      '80': null,
      '90': 'วันที่แก้ไขล่าสุด',
      '100': 'โดย',
      '110': null
    },
    'STDEMPP4': {
      '10': 'ข้อมูลภาษี',
      '20': 'รายละเอียดภาษี',
      '30': 'หมายเลขผู้เสียภาษี',
      '40': 'เลขที่ประกันสังคม',
      '50': '*',
      '60': '*',
      '70': 'รายละเอียดธนาคาร',
      '80': 'ธนาคาร',
      '90': 'เลขที่บัญชี',
      '100': 'ยอดเงิน',
      '110': 'ธนาคาร',
      '120': 'เลขที่บัญชี',
      '130': '*',
      '140': 'ลำดับ',
      '150': 'รายละเอียด',
      '160': '*',
      '170': 'ยอดเงิน',
      '180': '*',
      '190': 'วันที่',
      '200': '*',
      '210': '*',
      '220': '*',
      '230': '*',
      '240': 'วันที่ปรับปรุง',
      '250': 'โดย'
    },
    'STDEMPP5': {
      '10': '*',
      '20': null,
      '30': null,
      '40': 'รายละเอียด',
      '50': null,
      '60': null,
      '70': null,
      '80': null,
      '90': null,
      '100': null,
      '110': null,
      '120': null,
      '130': 'วันที่แก้ไขล่าสุด',
      '140': 'โดย'
    },
    'STDEMPP6': {
      '10': null,
      '20': null,
      '30': null,
      '40': null,
      '50': null,
      '60': null,
      '70': null,
      '80': null,
      '90': null,
      '100': 'วุฒิการศึกษา',
      '110': 'วันที่แก้ไขล่าสุด',
      '120': 'โดย'
    },
    'STDEMPP7': {
      '10': null,
      '20': null,
      '30': null,
      '40': 'ตำแหน่ง',
      '50': null,
      '60': null,
      '70': 'วันที่แก้ไขล่าสุด',
      '80': 'โดย',
      '90': null,
      '100': null,
      '110': null,
      '120': 'ตำแหน่ง',
      '130': null,
      '140': null,
      '150': null,
      '160': null,
      '170': null,
      '180': 'วันที่ลาออก',
      '190': null
    },
    'STDEMPP8': {
      '10': 'ข้อมูลครอบครัว',
      '20': 'ประวัติครอบครัว',
      '30': '*',
      '40': 'ชื่อบิดา',
      '50': '*',
      '60': '*',
      '70': '*',
      '80': '*',
      '90': '*',
      '100': '*',
      '110': '*',
      '120': '*',
      '130': '*',
      '140': '*',
      '150': 'ที่อยู่',
      '160': '*',
      '170': '*',
      '180': '*',
      '190': '*',
      '200': '*',
      '210': '*',
      '220': 'โดย'
    },
    'STDEMPP9': {
      '10': '*',
      '20': '*',
      '30': '*',
      '40': '*',
      '50': 'อาชีพ',
      '60': 'หน่วยงาน',
      '70': '*',
      '80': '*',
      '90': '*',
      '100': '*',
      '110': 'ประเทศ',
      '120': '*',
      '130': '*',
      '140': 'โดย',
      '150': 'โดย'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/stdemp.js